<template>
  <div>
    <div class="weeklyReport-title">
      <div>周报</div>
      <div>
        <Button
          v-hasPermission="['monitor:weeklyReport:add_alert_rule']"
          type="primary"
          @click="addOrUpdateHandle"
          >添加周报报警规则</Button
        >
        <add-or-update-weekly-report-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-weekly-report-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.common.alertRule')">
          <div class="weeklyReport-top">
            <weekly-report-warning-search></weekly-report-warning-search>
          </div>
          <table-weekly-report-warning></table-weekly-report-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import WeeklyReportWarningSearch from "../weeklyReport/WeeklyReportWarningSearch";
import TableWeeklyReportWarning from "../weeklyReport/TableWeeklyReportWarning";
import AddOrUpdateWeeklyReportWarning from "../weeklyReport/AddOrUpdateWeeklyReportWarning";

export default {
  name: "WeeklyReport",
  components: {
    WeeklyReportWarningSearch,
    TableWeeklyReportWarning,
    AddOrUpdateWeeklyReportWarning
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.weeklyReport-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}

.weeklyReport-title > div:nth-child(1) {
  float: left;
}

.weeklyReport-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}

.weeklyReport-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/weeklyReport/WeeklyReport.vue